import { FC, useCallback } from 'react';
import graphql from 'babel-plugin-relay/macro';

import Paper from '@mui/material/Paper';
import Alert from '@mui/material/Alert';
import FlightPriceHistoryTable from 'components/FlightPriceHistoryTable';

import { usePagination } from 'components/Pagination';
import { useAvoidSuspense, useSkipFirstLoad } from 'lib';

import { FlightEditPriceHistory_flight$key } from '__generated__/FlightEditPriceHistory_flight.graphql';
import Query, {
  FlightEditPriceHistoryRefetchQuery,
} from '__generated__/FlightEditPriceHistoryRefetchQuery.graphql';

type Props = {
  flight: FlightEditPriceHistory_flight$key;
};

const FlightEditPriceHistory: FC<Props> = props => {
  const { variables } = usePagination();

  const [{ id, history }, { refetch, loading }] = useAvoidSuspense<
    FlightEditPriceHistoryRefetchQuery,
    FlightEditPriceHistory_flight$key
  >(
    graphql`
      fragment FlightEditPriceHistory_flight on Flight
      @refetchable(queryName: "FlightEditPriceHistoryRefetchQuery") {
        id
        history(first: $first, after: $after) {
          ...FlightPriceHistoryTable_history
        }
      }
    `,
    props.flight,
    Query
  );

  useSkipFirstLoad(
    useCallback(() => {
      refetch({
        id,
        ...variables,
      });
    }, [id, refetch, variables])
  );

  if (!history) {
    return <Alert variant="filled">Dar nėra skrydžio istorijos</Alert>;
  }

  return (
    <Paper sx={{ pl: 2, pr: 2, pt: 1 }}>
      <FlightPriceHistoryTable loading={loading} history={history} />
    </Paper>
  );
};

export default FlightEditPriceHistory;
